import { useCallback, useEffect, useRef, useState } from 'react';
import { fetchUnreadCount } from './api';

const POLL_MS = 30000;

/** Счётчик непрочитанных с периодическим опросом (поллинг). */
export function useUnreadMessages(enabled: boolean) {
  const [unread, setUnread] = useState(0);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  const refresh = useCallback(async () => {
    try {
      setUnread(await fetchUnreadCount());
    } catch {
      /* тихо игнорируем сетевые сбои опроса */
    }
  }, []);

  useEffect(() => {
    if (!enabled) {
      setUnread(0);
      return;
    }
    refresh();
    timer.current = setInterval(refresh, POLL_MS);
    return () => {
      if (timer.current) clearInterval(timer.current);
    };
  }, [enabled, refresh]);

  return { unread, refresh };
}
